import apiClient from '../index';

export const locationApi = {

    searchLocations: async (keyword) => {
        try {
            const response = await apiClient.get('/search-location', {
                params: { keyword }
            });
            // Handle various common API response wrappers
            const data = Array.isArray(response?.data) ? response.data :
                Array.isArray(response?.data?.data) ? response.data.data : [];

            return data;
        } catch (error) {
            console.error('Error fetching locations:', error);
            return [];
        }
    },

    getLocationById: async (id) => {
        try {
            const response = await apiClient.get(`/locations/${id}`);
            return response?.data?.data || response?.data;
        } catch (error) {
            // Fallback: Try searching for the ID to see if it works
            try {
                const searchRes = await apiClient.get('/search-location', { params: { keyword: id } });
                const data = Array.isArray(searchRes?.data) ? searchRes.data :
                    Array.isArray(searchRes?.data?.data) ? searchRes.data.data : [];
                return data.find(loc => loc.id == id) || null;
            } catch (fallbackError) {
                console.error('Error fetching location by id:', fallbackError);
                return null;
            }
        }
    }
};

export default locationApi;
